var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ibx-app-loading"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"ibx-app-loading__message"},[_c('font-awesome-icon',{staticClass:"icon fa-spin",attrs:{"icon":['fad', 'spinner-third']}}),_c('div',{staticClass:"text"},[_vm._v("Loading Item Bank")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }